<template>
  <div v-if="props.link !== null" class="floating-edit-toggler">
    <NuxtLink :to="link" target="_blank" :external="true" class="button-toggler">
      <i class="fa fa-solid fa-edit text-2xl"></i>
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ link: string | null }>()
</script>

<style lang="postcss" scoped>
.floating-edit-toggler {
  position: fixed;
  bottom: 7.5rem;
  left: 0;
  margin: 1rem;
  z-index: 50;
  background-color: theme('colors.white');
  border-radius: theme('borderRadius.md');
  border: 1px solid theme('colors.brand.highlight');

  .button-toggler {
    display: block;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: theme('colors.brand.primary');
    border-radius: theme('borderRadius.md');
    color: theme('colors.brand.highlight');
    min-width: 4rem;
    text-align: center;

    @apply dark:bg-dmGray5;
  }
}
</style>
